import { WarningRounded } from '@mui/icons-material';
import { Alert, alpha, Typography } from '@mui/material';

import { alertStyles } from './styles';

interface ErrorAlertProps {
  error: string;
}

export const ErrorAlert = ({ error }: ErrorAlertProps) => {
  return (
    <Alert
      icon={<WarningRounded color="salmon" />}
      severity="error"
      sx={[
        alertStyles.root,
        { backgroundColor: theme => alpha(theme.palette.salmon, 0.1) },
      ]}>
      <Typography variant="body3" color="salmon">
        {error}
      </Typography>
    </Alert>
  );
};
